import React, { useState}from "react";
import "./AnimatedBanner.css";
import { motion } from "framer-motion";
import LoginModal from "../../modals/LoginModal/LoginModal";

const AnimatedBanner = () => {
    // const tabletBanner = '/assets/qinto_featured_ads_banner_728.png';
    // const laptopBanner = '/assets/qinto_featured_ads_banner_1440.png';
    // const desktopBanner = '/assets/qinto_featured_ads_banner_1920.png';
    // const mobileBanner = '/assets/qinto_featured_ads_banner_1200.png';

    const tabletBanner = '/assets/qinto_offer_banner_728.png';
    const laptopBanner = '/assets/qinto_offer_banner_1440.png';
    const desktopBanner = '/assets/qinto_offer_banner_1920.png';
    const mobileBanner = '/assets/qinto_offer_banner_1200.png';

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

    const handleClaimClick = () => {
    setIsLoginModalOpen(true);
  };

    return (
        <div className="banner-wrapper">
            {/* THIS is now the motion.div. We animate ITS background. */}
            <motion.div
                className="animated-motion-frame"
                // Animate the custom CSS property from 0deg to 360deg
                animate={{ "--angle": "360deg" }}
                // Define the smooth, endless, linear transition
                transition={{
                    duration: 8,
                    repeat: Infinity,
                    ease: "linear",
                }}
            >
                {/* The inner content masks the center of the animated background */}
                <div
                    className="banner-content"
                    onClick={handleClaimClick}
                >
                    <picture>
                        <source media="(min-width: 1440px)" srcSet={desktopBanner} />
                        <source media="(min-width: 1024px)" srcSet={laptopBanner} />
                        <source media="(min-width: 768px)" srcSet={tabletBanner} />
                        <img
                            src={mobileBanner}
                            alt="Download the Qinto App today"
                            className="banner-image"
                            loading="lazy"
                        />
                    </picture>
                </div>
            </motion.div>

            <LoginModal
                      isOpen={isLoginModalOpen}
                      onClose={() => setIsLoginModalOpen(false)}
                    />
        </div>
    );
};

export default AnimatedBanner;